/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Allocation_Form_MonthsInputs */

const en_admin_allocation_form_months = /** @type {(inputs: Admin_Allocation_Form_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`months`)
};

const de_admin_allocation_form_months = /** @type {(inputs: Admin_Allocation_Form_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monate`)
};

const es_admin_allocation_form_months = /** @type {(inputs: Admin_Allocation_Form_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`meses`)
};

const fr_admin_allocation_form_months = /** @type {(inputs: Admin_Allocation_Form_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mois`)
};

const nl_admin_allocation_form_months = /** @type {(inputs: Admin_Allocation_Form_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`maanden`)
};

/** @type {(inputs: Admin_Allocation_Form_MonthsInputs) => LocalizedString} */
const it_admin_allocation_form_months = en_admin_allocation_form_months;

/** @type {(inputs: Admin_Allocation_Form_MonthsInputs) => LocalizedString} */
const pt_br2_admin_allocation_form_months = en_admin_allocation_form_months;

/** @type {(inputs: Admin_Allocation_Form_MonthsInputs) => LocalizedString} */
const pl_admin_allocation_form_months = en_admin_allocation_form_months;

/** @type {(inputs: Admin_Allocation_Form_MonthsInputs) => LocalizedString} */
const hu_admin_allocation_form_months = en_admin_allocation_form_months;

/** @type {(inputs: Admin_Allocation_Form_MonthsInputs) => LocalizedString} */
const ro_admin_allocation_form_months = en_admin_allocation_form_months;

/**
* | output |
* | --- |
* | "months" |
*
* @param {Admin_Allocation_Form_MonthsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_allocation_form_months = /** @type {((inputs?: Admin_Allocation_Form_MonthsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Allocation_Form_MonthsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_allocation_form_months(inputs)
	if (locale === "de") return de_admin_allocation_form_months(inputs)
	if (locale === "es") return es_admin_allocation_form_months(inputs)
	if (locale === "fr") return fr_admin_allocation_form_months(inputs)
	if (locale === "nl") return nl_admin_allocation_form_months(inputs)
	if (locale === "it") return it_admin_allocation_form_months(inputs)
	if (locale === "pt-BR") return pt_br2_admin_allocation_form_months(inputs)
	if (locale === "pl") return pl_admin_allocation_form_months(inputs)
	if (locale === "hu") return hu_admin_allocation_form_months(inputs)
	return ro_admin_allocation_form_months(inputs)
});
export { admin_allocation_form_months as "admin.allocation_form.months" }